import { IComponentOptions } from 'angular';

export const ActionButtonsComponent: IComponentOptions = {
  template: require('./action-buttons.html'),
  bindings: {
    nextStep: '&',
    prevStep: '&',
  },
};

angular.module('nv.SupportsModule').component('actionButtons', ActionButtonsComponent);
